import { useQuery } from '@tanstack/react-query';
import { useDemo } from '../../../demo/DemoContext';
import { demoCategories, demoCombos } from '../../../demo/newScreens';
import { useWorkspace } from '../../stores';
import { listCatalog, type CatalogItem, type CatalogKind } from '../api/catalogApi';
export function useCatalog(kind: CatalogKind) {
  const { isDemo, store, scopeKey } = useWorkspace(); const demo = useDemo();
  const revision = isDemo && kind === 'services' ? JSON.stringify(demo.services) : '';
  return useQuery<CatalogItem[]>({ queryKey: [...scopeKey, 'catalog', kind, revision], queryFn: ({ signal }) => isDemo ? Promise.resolve(kind === 'services' ? demo.services.filter(s => s.store_id === store?.id) : kind === 'categories' ? demoCategories : demoCombos) : listCatalog(kind, signal), enabled: Boolean(store?.id), staleTime: 60_000 });
}
